import { environment } from 'environments/environment';

export const API_ENDPOINTS = {
    BASE_URL: environment.baseUrl,

    /* IMSME */
    IMSME_CHANGE_PASSWORD: 'auth/imsme/changepassword',
    IMSME_CHANGE_FORGET_PASSWORD: 'auth/imsme/changeforgetpassword',
    IMSME_FORGET_PASSWORD: 'auth/imsme/forgetpassword',
    IMSME_GENERATE_SMS_OTP: 'auth/imsme/generatesmsotp',
    IMSME_VERIFY_SMS_OTP: 'auth/imsme/verifysmsotp',
    IMSME_GET_USER: 'auth/imsme/getuser',
    IMSME_REGISTER_USER: 'auth/imsme/registeruser',
    IMSME_RESEND_REGISTRATION_EMAIL: 'auth/imsme/resendregistrationemail',
    IMSME_VERIFY_REGISTRATION: 'auth/imsme/verifyregistration',
    IMSME_UPDATE_ATTRIBUTE: 'auth/imsme/updateattribute',
    IMSME_SUBMIT_BUSINESS_CARD_AUTH: 'auth/imsme/businesscard',
    IMSME_SUBMIT_BUSINESS_CARD_NOAUTH: 'noauth/businesscard',
    IMSME_SUBMIT_CHATBOT_RATING_AUTH: 'auth/imsme/chatbot',
    IMSME_SUBMIT_CHATBOT_RATING_NOAUTH: 'noauth/chatbot',

    /*Profile */
    IMSME_UPDATE_PROFILE: 'auth/imsme/updateprofile',
    REDEEM: 'auth/imsme/redeemcode',
    REFERRAL_SUMMRY: 'auth/imsme/referralsummary',
    UPLOAD_PROFILE_PIC: 'pavems/storage/upload',
    GET_PROFILE_PIC: 'pavems/storage/retrieve',
    NOTIFICATIONS: 'imsme/notifications',
    NOTIFICATIONS_COUNT: 'imsme/notifications/count',
    READ_NOTIFICATION: 'imsme/notifications/read',

    /*imSME-plus Backoffice*/
    FAQ: 'imsme/faq',
    GRANTS: 'imsme/products/miti',
    HOMEPAGE: 'imsme/homepage',
    NEWS: 'imsme/news',
    PRODUCT_RECOMMENDATION: 'imsme/productrules/getrecommendation',
    PRODUCTS: 'imsme/products',
    TESTIMONY: 'imsme/testimony',
    CONTACT_US: 'imsme/contactus',
    PARTNERS: 'imsme/agency',
    INSURANCE: 'imsme/products/insurance',
    INSURANCE_LEADS: 'imsme/insurance-leads',

    /* PAVE-PARTNER-API */
    PAVE_APPLICATION: 'pave/application',
    PAVE_CUSTOMER_DECISION: 'pave/customerdecision',
    PAVE_MONITOR: 'pave/monitor',
    PAVE_ONBOARD: 'pave/onboard',
    PAVE_ONBOARD_PEOPLE: 'pave/onboardpeople',
    PAVE_PREQUALIFY: 'pave/prequalify',

    /* PAVE-MS-API */
    CBM_CONFIRM_SUBJECT: 'pavems/cbm/confirmsubject',
    CBM_INITIAL_REQUEST: 'pavems/cbm/initialrequest',
    CBM_QUERY_BIRP: 'pavems/cbm/querybirp',
    QUERY_BIRP: 'pavems/querybirp',
    KYC_CONFIRM_SUBJECT: 'pavems/kyc/verifydirector',
    PRODUCT_RULE_GET_RECOMMENDATION: 'pavems/productrule/getrecommendation',
    PRODUCT_RULE: 'pavems/productrule/',
    SEND_BULK_EMAIL: 'pavems/sendbulkemail',
    SEND_EMAIL: 'pavems/sendemail',

    // Access API
    SIGN_UP: 'auth/imsme/registeruser',
    CONFIRM_SIGN_UP: 'auth/imsme/confirmsignup',
    RESEND_SIGN_UP_EMAIL: 'auth/imsme/resendregistrationemail',
    LOGIN: 'auth/imsme/login',
    LOGOUT: 'auth/imsme/logout',
    FORGOT_PASSWORD: 'auth/imsme/forgotpassword',
    CONFIRM_FORGOT_PASSWORD: 'auth/imsme/confirmforgotpassword',
    REFRESH_TOKEN: 'auth/imsme/refreshtoken',
    VERIFY_TOKEN: 'auth/imsme/verifytoken',
    SEND_VERIFICATION_EMAIL: 'auth/imsme/resendverification',

    // Homepage API
    HOME_NEWS: 'imsme/news',
    HOME_CONTACT_US: '/imsme/contactus',

    //Product Listing
    GET_APP_PRODUCTS: 'imsme/products',
    SET_PRODUCT: 'imsme/case/setproduct',
    CREATE_CASE: 'imsme/case/createcase',
    GET_RECOMMENDATION: 'imsme/case/getrecommendation',
    GET_NO_MATCH_RECOMMENDATION: 'imsme/listNoMatch',

    //Product Application Journey
    FINANCING_INFO: 'imsme/case/financinginfo',
    CHECK_BRN: 'imsme/case/checkbrn',
    REFRESH_DETAILS: 'imsme/case/checkbrn',
    CHECK_KYC: 'imsme/case/checkkyc',
    BUSINESS_INFO: 'imsme/case/businessinfo',
    CHECK_ELIGIBILITY: 'imsme/case/checkeligibility',
    SUBMISSION: 'imsme/case/submission',
    GET_STATES: 'imsme/state',
    GET_CITIES: 'imsme/cities',

    //Case details

    GET_CASE: 'imsme/case',
    GET_CASE_DETAIL: 'imsme/casedetail',

    //Case drafts
    GET_DRAFTS: 'imsme/case/drafts',
    DELETE_DRAFTS: 'imsme/case/deletedraft',
    GET_CASE_STATUS: 'imsme/case/getcasestatus',
    UPLOAD_DOCUMENT: 'imsme/case/uploaddocument',
    DELETE_DOCUMENT: 'imsme/case/uploaddocument/delete',
    VIEW_DOCUMENT: 'imsme/case/viewdocument',

    GENERATE_OTP: 'auth/imsme/generatesmsotp',

    //LNDP Calendar
    CALENDAR: 'imsme/calendar',
    GET_WORKSHOP_QUESTION: 'imsme/workshop',
    SUBMIT_WORKSHOP_QUESTION: 'imsme/workshop/submission',
    MAINTENANCE: 'imsme/maintenance',
    GET_EVENT_DETAILS: 'imsme/calendar/eventdetail/',

    //GALLERY
    GET_GALLERY: 'imsme/images',

    //CAMPAIGN&PARTNERSHIP
    GET_ALL_CAMPAIGN: 'noauth/campaign',
    GET_CAMPAIGN_DETAILS_BY_ID: 'noauth/campaign/',
    GET_ALL_PARTNERSHIP: 'noauth/partnership',
    GET_PARTNERSHIP_DETAILS_BY_ID: 'noauth/partnership/',

    //Digital Service
    GET_DIGI_SERVICE_DATA: 'noauth/digital-services',
    DIGI_LEADS: 'imsme/digitalservice/leads',

    //JC3
    SEND_FEEDBACK: 'imsme/jc3/feedback',
    FETCH_FEEDBACK: 'imsme/jc3/feedback',
    EXPORT_FEEDBACK: 'imsme/jc3/feedback/export',
    CERTIFICATION: 'noauth/cmstree/CERTIFICATION',
    FINANCING: 'noauth/cmstree/FININFO',
    WHATS_NEW: 'noauth/cmstree/INTRO_WHATSNEW',
    SUCCESS_CONF: 'noauth/cmstree/SUCCESSCONF',
    SUCCESS_STORIES: 'noauth/cmstree/SUCCESSSTORIES',
    CAPACITY: 'noauth/cmstree/CAPACITY',

    JC3: {
        BANNER: 'noauth/cms/BANNER?sort=id,asc',
        HOMEPAGE: 'noauth/cms/HOMEPAGE?sort=id,asc',
        SWITCHER: 'noauth/cms/SWITCHER?sort=id,asc',
        WHATS_NEW:
            'noauth/cms/WHATNEW_ARTICLE?sort=id,asc&limit=1000&offset=0&status=ACTIVE&sort=publishdate',
        WHAT_IS_ESG: 'noauth/cms/WHATISESG?sort=id,asc',
        WHAT_IS_ESG_CARDS: 'noauth/cms/WHATISESGCARDS?sort=id,asc',
        WHY_ESG_MATTERS: 'noauth/cms/WHYESG?sort=id,asc',
        WHY_ESG_MATTERS_CARDS: 'noauth/cms/WHYESGCARDS?sort=id,asc',
        GET_STARTED_ESG_JC3: 'noauth/cms/STARTESG?sort=id,asc',
        GET_STARTED_ESG_JC3_CARDS: 'noauth/cms/STARTESGCARDS?sort=id,asc',
        SME_SUCCESS_STORIES:
            'noauth/cms/SUCCESSSTORIES?sort=id,asc&status=ACTIVE&sort=publishdate',

        // ----- Tab 2: Jumpstart ESG -----
        JUMPSTART_OVERVIEW_SWITCHER: 'noauth/cms/JUMPSTARTGUIDE?sort=id,asc',
        JUMPSTART_STEPS: 'noauth/cms/JUMPSTARTSTEPS?sort=id,asc',

        // ----- Tab 3: Capacity Building -----
        CAPACITY_TITLE_SWITCHER: 'noauth/cms/CAPACITY?sort=id,asc',
        CAPACITY_CARDS:
            'noauth/cms/CAPACITYCARDS?sort=id,asc&limit=1000&offset=0&status=ACTIVE&sort=publishdate',

        // ----- Tab 4: Certifications -----
        CERTIFICATION_TITLE_SWITCHER: 'noauth/cms/CERTIFICATION?sort=id,asc',
        CERTIFICATION_CARDS:
            'noauth/cms/CERTIFICATIONCARDS?sort=id,asc&limit=1000&offset=0&status=ACTIVE&sort=publishdate',

        // ----- Tab 5: Financial Solutions -----
        FINANCIAL_SOLUTIONS_TITLE_SWITCHER: 'noauth/cms/FININFO?sort=id,asc',
        FINANCIAL_SOLUTIONS_CARDS:
            'noauth/cms/FININFOCARDS?sort=title,asc&limit=1000&offset=0&status=ACTIVE&sort=publishdate',
    },
    NEWSLETTER: 'imsme/newsletter/subscribe',
};
